// EXAMPLE config
// [spaceKey]: {
//     contractAddress: '0x00',
//     chainId: 1
// }

export const REALM_CONTRACT_MAP = JSON.parse(process.env.NEXT_PUBLIC_REALM_CONTRACT_CONFIG);
